module.exports = __webpack_public_path__ + "img/alcool.ed1b017e.svg";